// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"JI-z","carouselContainer":"KI-z"};